import './Form.css';

const PageSelection = ({ numberOfScans, startAndEndCanvas, pages, onAllChange, onSomeChange, onRangeChange, error }) => {
  return (
    <>
      <div className="radio">
        <label>
          <input
            id="pages-all"
            name="pages-all"
            type="radio"
            checked={pages.all}
            onChange={onAllChange}
          />
          <span className="icon"></span>
          Gesamtes Objekt | {numberOfScans} Scans
        </label>
      </div>

      <div>
        <div className="radio">
          <label>
            <input
              id="pages-some"
              name="pages-some"
              type="radio"
              checked={!pages.all}
              onChange={onSomeChange}
            />
            <span className="icon"></span>
            Scans
          </label>

          <label htmlFor="from" className="label-text-input">
            von
          </label>
          <input
            id="pages-from"
            name="from"
            type="number"
            min={startAndEndCanvas.start}
            max={startAndEndCanvas.end}
            disabled={pages.all}
            value={pages.from}
            onChange={onRangeChange}
            placeholder={startAndEndCanvas.start}
            className="label-text-input"
          />

          <label htmlFor="pages-to" className="label-text-input">
            bis
          </label>
          <input
            id="pages-to"
            name="to"
            min={startAndEndCanvas.start}
            max={startAndEndCanvas.end}
            type="number"
            disabled={pages.all}
            value={pages.to}
            onChange={onRangeChange}
            placeholder={startAndEndCanvas.end}
          />
          {error && <p className="error">{error}</p>}
        </div>
      </div>

    </>
  );
};

export default PageSelection;
